import {
  NotificationEntityType,
  NotificationPayload,
  NotificationRoutes,
} from '../types/notification-types';

class NotificationNavigator {
  private static instance: NotificationNavigator;
  private navigate: ((path: string) => void) | null = null;

  static getInstance(): NotificationNavigator {
    if (!this.instance) {
      this.instance = new NotificationNavigator();
    }
    return this.instance;
  }

  setNavigate(navigateFn: (path: string) => void): void {
    this.navigate = navigateFn;
  }

  handleNotificationTap(payload: NotificationPayload): void {
    console.log('[NotificationNavigator] Handling tap:', payload);

    if (!this.navigate) {
      console.warn('[NotificationNavigator] Navigate function not set');
      return;
    }

    const { type, entityId } = payload;

    // Use route mapping from types
    const routeBuilder = NotificationRoutes[type as NotificationEntityType];
    if (!routeBuilder) {
      console.warn('[NotificationNavigator] Unknown notification type:', type);
      return;
    }

    const path = routeBuilder(entityId);
    console.log('[NotificationNavigator] Navigating to:', path);
    this.navigate(path);
  }
}

export const notificationNavigator = NotificationNavigator.getInstance();
